import { getContext } from 'svelte';
import { get, writable } from 'svelte/store';
import { ContextStateSymbol } from '../context';
export function useConnect() {
    const { walletModal } = getContext(ContextStateSymbol);
    const $walletModal = get(walletModal);
    const isConnecting = writable(false);
    return {
        isConnecting,
        async connect({ onConnecting, onError, onSuccess, onExit } = {}) {
            const unsubscribe = $walletModal.subscribeEvents(({ data: { event } }) => {
                if (event === 'MODAL_CLOSE' || event === 'CONNECT_SUCCESS') {
                    if (event === 'CONNECT_SUCCESS') {
                        if (onSuccess)
                            onSuccess();
                    }
                    if (onExit)
                        onExit();
                    if (unsubscribe)
                        unsubscribe();
                    isConnecting.set(false);
                }
            });
            if (onConnecting)
                onConnecting();
            isConnecting.set(true);
            try {
                await $walletModal.open({ view: 'Connect' });
            }
            catch (error) {
                if (onError)
                    onError(error);
                isConnecting.set(false);
            }
        },
    };
}
